import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import Message from '../components/Message';
import { createUser } from '../api/auth';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../store/auth-context';

const schema = yup.object().shape({
  username: yup.string().required('username is a required field'),
  email: yup.string().email().required('email is a required field'),
  password: yup.string().required('password is a required field'),
  confirmPassword: yup.string().oneOf([yup.ref('password'), null]),
});

const SignupScreen = () => {
  // const userRegister = useSelector((state) => state.userRegister);
  // const { loading, error, userInfo } = userRegister;

  let navigate = useNavigate();

  const { authenticate, isAuthenticated } = useAuth();
  const [error, setError] = useState(false);

  const redirect = '/';
  useEffect(() => {
    if (isAuthenticated) {
      navigate(redirect);
    }
  }, [error, isAuthenticated, navigate]);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
  });

  async function signupHandler(data) {
    ('/////////////////');
    if (!data.password || !data.email || !data.username) {
      setError('يرجى ادخال البريد الالكتروني و كلمة المرور');
    } else {
      try {
        const response = await createUser(
          data.email,
          data.password,
          data.username
        );
        if (response?.success) {
          // authenticate(response.token);
          navigate('/login');
        } else if (response?.success === false) {
          setError(response?.error);
        } else {
          setError(response);
        }
      } catch (error) {
        setError(error);
      }
    }
  }

  const onSubmit = (data, e) => {
    e.preventDefault();
    signupHandler(data);
  };

  return (
    <div className='min-h-screen w-full bg-cool-200 md:pt-14' dir='rtl'>
      {/* {loading && <Loader />} */}
      <div className='container max-w-3xl py-10 md:px-16 px-3'>
        {error && (
          <div className=''>
            {' '}
            <Message>{error}</Message>
          </div>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='grid grid-rows-2 gap-4 '>
            <div className='grid md:grid-cols-2 grid-cols-1 gap-4 '>
              <div>
                <label className='text-sm font-bold text-gray-600 block'>
                  <i className='fas fa-user'></i>
                  <span className='px-1'>الاسم</span>
                </label>
                <input
                  className='w-full p-2 border border-gray-300 rounded mt-1'
                  type='text'
                  name='username'
                  {...register('username')}
                ></input>
                <p className=' opacity-50 text-s'>
                  {errors?.username?.message}
                </p>
              </div>

              <div>
                <label className='text-sm font-bold text-gray-600 block'>
                  <i className='fas fa-envelope-open-text'></i>
                  <span className='px-1'>البريد الالكتروني</span>
                </label>
                <input
                  className='w-full p-2 border border-gray-300 rounded mt-1'
                  type='email'
                  {...register('email')}
                ></input>
                <p className=' opacity-50 text-s'>{errors?.email?.message}</p>
              </div>
            </div>

            <div className='grid md:grid-cols-2 grid-cols-1 gap-4'>
              <div>
                <label className='text-sm font-bold text-gray-600 block'>
                  <i className='fas fa-user-lock'></i>
                  <span className='px-1'>كلمة السر</span>
                </label>
                <input
                  className='w-full p-2 border border-gray-300 rounded mt-1'
                  type='password'
                  {...register('password')}
                ></input>
                <p className=' opacity-50 text-s'>
                  {errors?.password?.message}
                </p>
              </div>

              <div>
                <label className='text-sm font-bold text-gray-600 block'>
                  <i className='fas fa-user-lock'></i>
                  <span className='px-1'>تاكيد كلمة السر</span>
                </label>
                <input
                  className='w-full p-2 border border-gray-300 rounded mt-1'
                  type='password'
                  {...register('confirmPassword')}
                ></input>
                <p className=' opacity-50 text-s'>
                  {errors.confirmPassword && 'Passwords Shoud match!'}
                </p>
              </div>
            </div>
            <div className='grid md:grid-cols-2 grid-cols-1 gap-4'></div>
          </div>
          <div className='pt-10'>
            <button
              type='submit'
              className='w-full bg-altaqnya-100 hover:bg-altaqnya-200 text-white font-medium px-4 py-2 rounded shadow-md '
            >
              انشاء حساب
            </button>
          </div>
        </form>
        <div className='flex justify-center pt-3'>
          {`لديك حساب؟ `}
          <a
            className='text-altaqnya-100 hover:underline hover:text-altaqnya-100 '
            href='/login'
          >
            &nbsp;تسجيل دخول
          </a>
        </div>
      </div>
    </div>
  );
};

export default SignupScreen;
